module.exports = __webpack_public_path__ + "static/media/redux.b3e5602f.svg";